<script setup lang="ts"></script>

<template>
  <div class="mb-6 flex flex-wrap items-end text-xs sm:text-sm xl:mb-4">
    <slot></slot>
  </div>
</template>
